import React, { useState, useEffect } from 'react';
import "./BlinkingStar.css";

const BlinkingStar = ({ imageSrc, title }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsVisible((prevVisible) => !prevVisible);
        }, 500); // Adjust blinking speed here (milliseconds)

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={`blinking-star star-back star-text ${isVisible ? 'visible' : 'hidden'}`}>
            <img src={imageSrc} alt={title} />
            <h6>{title}</h6>
        </div>
    );
};

export default BlinkingStar;
